import { createSelector, createSlice } from '@reduxjs/toolkit';

const getInitialState = () => ({
  currentLoadedProduct: null,
  linkedShelfProps: null,
  linkedMaterials: null,
  linkedTextures: null,
  isAddShelfPropFromTag: false,
  isAddMaterialFromTag: false,
  isAddTextureFromTag: false,
  tagListShelfProp: null,
  tagListMaterials: null,
  tagListTextures: null,
  savedPropductFromApi: null,
});

const productSetup = createSlice({
  name: 'productSetup',
  initialState: getInitialState(),
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    setCurrentLoadedProduct: (state, { payload }) => {
      state.currentLoadedProduct = payload;
    },
    setIsAddShelfPropFromTag: (state, { payload }) => {
      state.isAddShelfPropFromTag = payload;
    },
    setIsAddTextureFromTag: (state, { payload }) => {
      state.isAddTextureFromTag = payload;
    },
    setIsAddMaterialFromTag: (state, { payload }) => {
      state.isAddMaterialFromTag = payload;
    },
    setTagListFromShelfProp: (state, { payload }) => {
      state.tagListShelfProp = payload;
    },
    setTagListFromMaterial: (state, { payload }) => {
      state.tagListMaterials = payload;
    },
    setTagListFromTexture: (state, { payload }) => {
      state.tagListTextures = payload;
    },
    setSavedProductFromApi: (state, { payload }) => {
      state.savedPropductFromApi = payload;
    }
  },
});

export const productSetupActions = productSetup.actions;
export const productSetupReducer = productSetup.reducer;
export default productSetupReducer;
export const selectCurrentLoadedProduct = (state) => state.productSetup.currentLoadedProduct;
export const selectIsAddShelfPropFromTag = (state) => state.productSetup.isAddShelfPropFromTag;
export const selectIsAddTextureFromTag = (state) => state.productSetup.isAddTextureFromTag;
export const selectIsAddMaterialFromTag = (state) => state.productSetup.isAddMaterialFromTag;
export const selectTagListFromShelfProp = (state) => state.productSetup.tagListShelfProp;
export const selectTagListFromTextures = (state) => state.productSetup.tagListTextures;
export const selectTagListFromMaterials = (state) => state.productSetup.tagListMaterials;
export const selectSavedProductFromApi = (state) => state.productSetup.savedPropductFromApi;